module.exports = __webpack_public_path__ + "img/19_27.8bf6dc19.png";